/* ============================================
   Delivery Day Auto-Replace
   ----------------------------------------------
   Vervangt "morgen" met de actuele bezorg-dag
   in elk element met `data-auto-delivery`.

   Mapping (orderdag → bezorgdag):
     Maandag    → Dinsdag
     Dinsdag    → Woensdag
     Woensdag   → Donderdag
     Donderdag  → Vrijdag
     Vrijdag    → Zaterdag
     Zaterdag   → Dinsdag (skipt zo + ma)
     Zondag     → Dinsdag

   Tijdzone: Europe/Amsterdam (NL).
   Run on initial load + Shopify section reload events.
   ============================================ */
(function () {
  'use strict';

  var DELIVERY_BY_SHORT = {
    Sun: 'Dinsdag',
    Mon: 'Dinsdag',
    Tue: 'Woensdag',
    Wed: 'Donderdag',
    Thu: 'Vrijdag',
    Fri: 'Zaterdag',
    Sat: 'Dinsdag'
  };

  // Fallback voor oude browsers zonder Intl
  var FALLBACK_BY_INDEX = ['Dinsdag','Dinsdag','Woensdag','Donderdag','Vrijdag','Zaterdag','Dinsdag'];

  function getDeliveryDay() {
    try {
      var formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Amsterdam',
        weekday: 'short'
      });
      var short = formatter.format(new Date());
      return DELIVERY_BY_SHORT[short] || 'morgen';
    } catch (e) {
      return FALLBACK_BY_INDEX[new Date().getDay()];
    }
  }

  // Patronen die we vervangen door de bezorg-dag.
  // Volgorde matters: langste matches eerst.
  var REPLACE_PATTERNS = [
    /\bde\s+volgende\s+werkdag\b/gi,
    /\bvolgende\s+werkdag\b/gi,
    /\bmorgen\b/gi
  ];

  function hasMatch(text) {
    for (var i = 0; i < REPLACE_PATTERNS.length; i++) {
      REPLACE_PATTERNS[i].lastIndex = 0;
      if (REPLACE_PATTERNS[i].test(text)) return true;
    }
    return false;
  }

  function replaceTextNode(node, label) {
    var text = node.nodeValue;
    if (!hasMatch(text)) return;
    REPLACE_PATTERNS.forEach(function (re) {
      re.lastIndex = 0;
      text = text.replace(re, label);
    });
    node.nodeValue = text;
  }

  function walkAndReplace(root, label) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var nodesToProcess = [];
    var node;
    while ((node = walker.nextNode())) {
      if (hasMatch(node.nodeValue)) {
        nodesToProcess.push(node);
      }
    }
    nodesToProcess.forEach(function (n) { replaceTextNode(n, label); });
  }

  function update(scope) {
    var label = getDeliveryDay();
    var root = scope || document;
    var elements = root.querySelectorAll('[data-auto-delivery]');
    elements.forEach(function (el) {
      walkAndReplace(el, label);
      // Mark as processed zodat we niet dubbel vervangen
      el.dataset.deliveryReplaced = label;
    });

    // Templates met expliciete {day} placeholder
    var templated = root.querySelectorAll('[data-delivery-day]');
    templated.forEach(function (el) {
      var template = el.dataset.deliveryTemplate || el.getAttribute('data-delivery-template') || '<strong>Voor 23:59 besteld</strong> = {day} in huis';
      el.innerHTML = template.replace(/\{day\}/g, label);
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { update(); });
  } else {
    update();
  }

  // Re-run wanneer Shopify section opnieuw gerendered wordt (theme editor)
  document.addEventListener('shopify:section:load', function (e) {
    update(e.target);
  });

  // Custom event voor scripts die nieuwe content injecteren (wishlist, recently viewed)
  document.addEventListener('delivery-day:refresh', function (e) {
    update(e.detail && e.detail.scope ? e.detail.scope : null);
  });

  // Universele hook: cards:rendered event wordt door alle product-row sections
  // gedispatched (row-trending, recently-viewed, wishlist, atc-modal upsells, etc).
  // Hierdoor krijgen ALLE dynamisch toegevoegde cards automatisch de bezorg-dag
  // tekst zonder dat elke section apart delivery-day:refresh hoeft te dispatchen.
  document.addEventListener('cards:rendered', function (e) {
    update(e.detail && e.detail.scope ? e.detail.scope : null);
  });

  // Globale helper voor inline scripts
  window.candyDeliveryDay = {
    get: getDeliveryDay,
    refresh: function (scope) { update(scope); }
  };
})();
